export const casingWeightConstant = {
    "4.5": "13.5",
    "5.5": "17",
    "7": "26",
    "9.625": "40",
};

export const designType = {
    1: "ESP",
    2: "Jet lift",
};